// extracted by mini-css-extract-plugin
export const headBgColorExternal = "#ffffff";
export const headBgColorInternal = "#1c2234";
export const headBgColorShrunkSidebar = "#3c425a";
export const regular = "400";
export const medium = "500";
export const semibold = "600";
export const bold = "700";
export const sans = "'sans'";
export const serif = "'serif'";
export const atlasGrotesk = "'AtlasGrotesk'";
export const textCenter = "CarSettingsModule__textCenter__EaJV1";
export const table = "CarSettingsModule__table__ifnTd";
export const tableInner = "CarSettingsModule__tableInner__oK0HK";
export const headerRow = "CarSettingsModule__headerRow__Q-8qu";
export const white = "CarSettingsModule__white__4kk2m";
export const headerCell = "CarSettingsModule__headerCell__3innX";
export const responsiveTitle = "CarSettingsModule__responsiveTitle__Lx+9y";
export const responsiveTitleText = "CarSettingsModule__responsiveTitleText__PYfH9";
export const headerTitle = "CarSettingsModule__headerTitle__KzBC7";
export const sortingWrapper = "CarSettingsModule__sortingWrapper__1geEd";
export const withHelpText = "CarSettingsModule__withHelpText__qA3C9";
export const up = "CarSettingsModule__up__va82v";
export const down = "CarSettingsModule__down__xMxf7";
export const body = "CarSettingsModule__body__VMNHH";
export const row = "CarSettingsModule__row__bF-+P";
export const cell = "CarSettingsModule__cell__qZivt";
export const footer = "CarSettingsModule__footer__F6bAH";
export const paginatorWrapper = "CarSettingsModule__paginatorWrapper__5x4zf";
export const pageSizeSelectorWrapper = "CarSettingsModule__pageSizeSelectorWrapper__97SYM";
export const tooltipIconWrapper = "CarSettingsModule__tooltipIconWrapper__gf6Xr";
export const debtsAccountDetails = "CarSettingsModule__debtsAccountDetails__8FZ2y";
export const creditAccountDetails = "CarSettingsModule__creditAccountDetails__szFHm";
export const accountsTable = "CarSettingsModule__accountsTable__Rrxpl";
export const pointing = "CarSettingsModule__pointing__fKkB2";
export const emptyState = "CarSettingsModule__emptyState__4qrIN BalanceAccountSettingsModule__emptyState__shYhk";
export const carsTable = "CarSettingsModule__carsTable__-Lao6";
export const hideForSmall = "CarSettingsModule__hideForSmall__cHOc9";